module.exports = __webpack_public_path__ + "img/Chargebee.e54fc5d5.svg";